<template>
  <div>
    <div class="my-2 d-flex align-items-center a-click" @click="expand">
      <span class="text-title font-logo me-auto">รายการสินค้า</span>
    </div>

    <div class="expand" :style="styleObject">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  props: {
    maxHeight: {
      type: String,
      default: '350',
    },
  },
  data() {
    return {
      statusExpand: true,
    };
  },
  methods: {
    expand() {
      // this.statusExpand = !this.statusExpand;
      // if (this.statusExpand) {
      //   this.styleObject.maxHeight = `${this.maxHeight}px`;
      // } else {
      //   this.styleObject.maxHeight = '0px';
      // }
    },
  },
  computed: {},
  watch: {},
  components: {},
};
</script>

<style>
.expand {
  transition: 0.5s ease all;
}
.turn-arrow {
  transform: rotate(180deg);
}
</style>
